import { AlternativeLogEntryReadModel } from "@Alternatives/Alternatives/Domain/readmodels";

export class LogsBrowserViewModel
{
    opened: boolean = false;
    initialized: boolean = false;
    logs: AlternativeLogEntryReadModel[] = [];

    show()
    {
        this.initialized = false;
        this.logs = [];

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
        this.logs = [];
    }

    setData(logs: AlternativeLogEntryReadModel[])
    {
        this.logs = logs;
        this.initialized = true;
    }
}